import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { regimeTypeOptions } from "../../linkedinrequests-options";

const TypeLinkedinRequestsDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
  inputType: string;
}> = ({ options, inputType }) => {
   const LinkedinRequestsStatusTypeOptions = [
    { label: "Pendente", value: "Pendente" },
    { label: "Em Progresso", value: "Em Progresso" },
    { label: "Concluído", value: "Concluído" },
  ];

  const LinkedinRequestsRecurringTypeOptions = [
    { label: "Sim", value: true },
    { label: "Não", value: false },
  ];

  const LinkedinRequestsRegimeTypeOptions = regimeTypeOptions.map((option) => ({
    label: option.label,
    value: option.value,
  }));

  return (
    <Dropdown
      value={options.value}
      options={inputType === "status" ? (LinkedinRequestsStatusTypeOptions) : (inputType === "recurring" ? LinkedinRequestsRecurringTypeOptions : LinkedinRequestsRegimeTypeOptions)}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo"
      showClear
    />
  );
};
export default TypeLinkedinRequestsDropdown;
